/**
 * @Description: 修改配送区域的界面饿百
 * @Author XuLailing
 * @Date 2020/9/14 10:17
 */
import React, {Component} from "react";
import {Button, Card, Input, List, message, Skeleton} from "antd";
import {Map, Marker, PolyEditor, Polygon} from "react-amap";
import './index.less'
import {getShopInfo, getShopUpdateDeliver} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

import {COMMON_ROUTER} from "../../../../constants";

// const count = 3;
// const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;
export default class EditAreaFlower extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      hasMore: true,
      shopId: '',
      addressGeo: [116.2317, 39.5427],
      deliverGeo: ''
    }
    this.editorEvents = {
      created: (ins) => {
        console.log(ins)
      },
      addnode: () => {
        console.log('polyeditor addnode')
      },
      adjust: () => {
        console.log('polyeditor adjust')
      },
      removenode: () => {
        console.log('polyeditor removenode')
      },
      end: (target) => {
        let allPath = target.target.getPath()
        console.log('allPath------------------------------------------')
        console.log(allPath)
        let pathTemp = []
        allPath.map((item, index) => {
          // let path = [item.lng, item.lat]
          let path = {latitude: item.lat, longitude: item.lng}
          pathTemp.push(path)
        })
        // let {selected, features} = this.state
        //         // if (features[selected]) {
        //         //   features[selected].geometry.coordinates = [pathTemp]
        //         //   this.setState({
        //         //     features: features
        //         //   })
        //         // }

        let {selected, deliverGeo} = this.state
        if (deliverGeo[selected]) {
          deliverGeo[selected].region = [pathTemp]
          this.setState({
            deliverGeo: deliverGeo
          })
        }
      },
    };
  }

  componentWillMount() {
    this.setState({
      shopId: this.props.location.state.shopId
    })
  }

  componentDidMount() {
    /* this.getDeliveryArea()*/
    this.getDeliveryArea()
  }

  getDeliveryArea() {
    getShopInfo({
      id: this.state.shopId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let addressGeo = data.data.addressGeo
          if (addressGeo == null || addressGeo == '') {
          } else {
            addressGeo = addressGeo.split(',');
          }
          let deliverGeo = data.data.deliverGeo
          deliverGeo = JSON.parse(deliverGeo)
          // let features = deliverGeo.features
          // let featureTemp = []
          // features.map((item, index) => {
          //   item['active'] = false;
          //   featureTemp.push(item)
          // })
          // this.setState({
          //   addressGeo: addressGeo,
          //   deliverGeo: deliverGeo,
          //   features: featureTemp
          // })

          let deliverTemp = []
          deliverGeo.map((item, index) => {
            item['active'] = false;
            deliverTemp.push(item)
          })
          this.setState({
            addressGeo: addressGeo,
            deliverGeo: deliverTemp,
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_DELIVERY_AREA, {
    //   id: this.state.shopId,
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     console.log('_____________')
    //     console.log(data)
    //     if (data.code === 0) {
    //       let addressGeo = data.data.addressGeo
    //       addressGeo = addressGeo.split(',');
    //       let deliverGeo = data.data.deliverGeo
    //       deliverGeo = JSON.parse(deliverGeo)
    //       // let features = deliverGeo.features
    //       // let featureTemp = []
    //       // features.map((item, index) => {
    //       //   item['active'] = false;
    //       //   featureTemp.push(item)
    //       // })
    //       // this.setState({
    //       //   addressGeo: addressGeo,
    //       //   deliverGeo: deliverGeo,
    //       //   features: featureTemp
    //       // })
    //
    //       let deliverTemp = []
    //       deliverGeo.map((item, index) => {
    //         item['active'] = false;
    //         deliverTemp.push(item)
    //       })
    //       this.setState({
    //         addressGeo: addressGeo,
    //         deliverGeo: deliverTemp,
    //       })
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  /**
   * @Description: 获取不同颜色的地图
   * @Author Jiang
   * @Date 2020/8/19 15:50
   */
  getAreaColor = (index) => {
    switch (index) {
      case 0:
        return 'rgba(255,38,16,0.55)'
      case 1:
        return 'rgba(255,207,37,0.59)'
      case 2:
        return 'rgb(29,122,25,0.5)'
      case 3:
        return 'rgb(45,47,235,0.5)'
      case 4:
        return 'rgb(255,52,234,0.5)'
      case 5:
        return 'rgb(54,255,54,0.5)'
      case 6:
        return 'rgba(194,149,255,0.59)'
      case 7:
        return 'rgba(255,30,12,0.76)'
    }
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  rad2deg(rad) {
    return rad * (180 / Math.PI)
  }

  squarePoint = (lng, lat, distance = 0.5) => {
    let dlng = 2 * Math.asin(Math.sin(distance / (2 * 6371) / Math.cos(this.deg2rad(lat))))
    dlng = this.rad2deg(dlng);
    let dlat = distance / 6371;
    dlat = this.rad2deg(dlat)

    // return [
    //   [lng + dlng, lat + dlat],//东北
    //   [lng - dlng, lat + dlat],//西北
    //   [lng - dlng, lat - dlat],//西南
    //   [lng + dlng, lat - dlat],//东南
    // ]
    return [
      {latitude: (lat + dlat), longitude: (lng + dlng)},//东北
      {latitude: (lat + dlat), longitude: (lng - dlng)},//西北
      {latitude: (lat - dlat), longitude: (lng - dlng)},//西南
      {latitude: (lat - dlat), longitude: (lng + dlng)},//东南
    ]
  }

  addArea = () => {
    if (this.state.deliverGeo.length > 0) {
      let temp = this.state.deliverGeo
      temp.map((item,index) => {
        item.active = false
      })
      this.setState({
        deliverGeo:temp
      },() => {
        let deliverGeoTemp = this.state.deliverGeo
        //根据店铺位置，获取4个点
        let center = this.state.addressGeo
        let lng = center[0]
        lng = parseFloat(lng)
        let lat = center[1]
        lat = parseFloat(lat)
        let coordinates = this.squarePoint(lng, lat, 2)
        console.log('&&&&&&&&&&&&&&&&&&&&')
        console.log(coordinates)
        let obj = {
          delivery_fee:0,
          delivery_time:0,
          min_buy_free:0,
          min_order_price:0,
          name:"区域",
          region: [coordinates],
        }
        deliverGeoTemp.push(obj)

        this.setState({
          deliverGeo: deliverGeoTemp
        })
      })
    } else {
      let deliverGeoTemp = []
      //根据店铺位置，获取4个点
      let center = this.state.addressGeo
      let lng = center[0]
      lng = parseFloat(lng)
      let lat = center[1]
      lat = parseFloat(lat)
      let coordinates = this.squarePoint(lng, lat, 2)
      let obj = {
        delivery_fee:0,
        delivery_time:0,
        min_buy_free:0,
        min_order_price:0,
        name:"区域",
        region: [coordinates],
        active: false,
      }
      deliverGeoTemp.push(obj)
      this.setState({
        deliverGeo: deliverGeoTemp
      })
    }
  }

  del = (index,e) => {
    e.stopPropagation()
    let deliverGeoTemp = this.state.deliverGeo;
    deliverGeoTemp.map((item,i) => {
      item.active = false
    })
    this.setState({
      deliverGeo: deliverGeoTemp
    },() => {
      let temp = this.state.deliverGeo
      temp.splice(index, 1)
      this.setState({
        deliverGeo: JSON.parse(JSON.stringify(temp))
      })
    })
  }

  onSelectArea = (index) => {

    let deliverGeoTemp = this.state.deliverGeo;
    let selected = ''
    for (let i = 0; i < deliverGeoTemp.length; i++) {
      if (deliverGeoTemp[i].active === true) {
        selected = i
      }
      if (i === index) {
        deliverGeoTemp[i].active = true
      } else {
        deliverGeoTemp[i].active = false
      }
    }
    this.setState({
      deliverGeo: deliverGeoTemp,
      selected: selected,
    })
  }

  save = () => {

    let deliverGeoTemp = this.state.deliverGeo;
    if (deliverGeoTemp.length === 0) {
      message.error('当前没有配送区域，请添加',1)
      return
    }
    let selected = ''
    for (let i = 0; i < deliverGeoTemp.length; i++) {
      if (deliverGeoTemp[i].active === true) {
        selected = i;
      }
      deliverGeoTemp[i].active = false
    }
    this.setState({
      selected: selected
    }, () => {
      this.setState({
        deliverGeo: deliverGeoTemp
      }, () => {
        let {deliverGeo} = this.state
        //处理修改数据
        console.log('*******************')
        console.log(deliverGeo)
        let deliverGeoTemp = JSON.stringify(deliverGeo)
        getShopUpdateDeliver({
          shopId: this.state.shopId,
          content: deliverGeoTemp
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              message.success('保存成功', 1, () => {
                this.props.history.push(COMMON_ROUTER + '/deliveryManage')
              })
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })

        // axios.post(API_SHOP_AREA_SAVE, {
        //   shopId: this.state.shopId,
        //   content: deliverGeoTemp
        // }).then(res => {
        //   console.log(res)
        //   if (res.status === 200) {
        //     let data = res.data;
        //     if (data.code === 0) {
        //       message.success('保存成功', 1, () => {
        //         this.props.history.push(COMMON_ROUTER + '/deliveryManage')
        //       })
        //     } else {
        //       message.error(data.msg, 1)
        //     }
        //   }
        // }).catch(error => {
        //
        // })
      })
    })
  }

  handleChange = (type, index, e) => {

    let {deliverGeo} = this.state
    // let properties = features[index].properties
    let delivery_fee = deliverGeo[index].delivery_fee
    let min_buy_free = deliverGeo[index].min_buy_free

    switch (type) {
      case "area_agent_fee":
        // properties.area_agent_fee = e.target.value
        min_buy_free = e.target.value
        break;
      case "delivery_price":
        // properties.delivery_price = e.target.value
        delivery_fee = e.target.value
        break;
      // case 'time_start':
      //   properties.multiPeriod.times[0][0] = e.target.value
      //   break;
      // case 'time_end':
      //   properties.multiPeriod.times[0][1] = e.target.value
      //   break;
      // case "max_weight":
      //   properties.max_weight = e.target.value
      //   break;
      default:
    }
    deliverGeo[index].delivery_fee = delivery_fee
    deliverGeo[index].min_buy_free = min_buy_free
    this.setState({
      deliverGeo: deliverGeo
    })
  }
  exist = () => {
    this.props.history.push(COMMON_ROUTER + '/deliveryManage')
  }


  render() {
    return (
      <div className='container-editarea'>
        { <Map zoom={12} amapkey={'e73ee0f829ee336137ca9eabdee6382e'}
                                       center={this.state.addressGeo}>
          <Marker position={this.state.addressGeo}/>
          {this.state.deliverGeo && this.state.deliverGeo.map((item, index) => {
            return <Polygon key={index} path={item.region[0]}
                            style={{fillColor: this.getAreaColor(index), strokeColor: this.getAreaColor(index)}}>
              <PolyEditor active={item.active} events={this.editorEvents}/>
            </Polygon>
          })}
        </Map>
        }


        <div className='delivery-area'>
          <Card title={'配送区域'} headStyle={{height: '10px', lineHeight: "10px", fontSize: "14px", fontWeight: "700"}}
                style={{width: '100%'}}>
            <div className='demo-infinite-containe'>
              <List
                className="demo-loadmore-list"
                itemLayout="horizontal"
                dataSource={this.state.deliverGeo}
                renderItem={(item, index) => (
                  <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <div className='editor-content' onClick={this.onSelectArea.bind(this, index)}>
                        <div className="editor-area__type"><span>区域 {index + 1}</span> <span
                          className="editor-area__btn--delete" onClick={this.del.bind(this, index)}>删除</span>
                        </div>
                        <div>
                          <div className={'row_label'}>
                            <span className={'label_price'}>起送价</span>
                            <Input className='input_price'
                                   onChange={this.handleChange.bind(this, 'area_agent_fee', index)}
                                   defaultValue={item.min_buy_free}
                                   addonAfter={'元'}/>
                          </div>
                          <div className={'row_label'}>
                            <span className={'label_price'}>配送费</span>
                            <Input className='input_price'
                                   onChange={this.handleChange.bind(this, 'delivery_price', index)}
                                   style={{marginBottom: "20px"}} defaultValue={item.delivery_fee}
                                   addonAfter={'元'}/>
                          </div>

                          {/*<div className={'row_label'}>*/}
                          {/*  <span className='label_price'>生效时间</span>*/}
                          {/*  <div className='effect_time'>*/}
                          {/*    <Input onChange={this.handleChange.bind(this, 'time_start', index)}*/}
                          {/*           defaultValue={item.properties.multiPeriod.times[0][0]}*/}
                          {/*           style={{border: 0, width: '65px', fontSize: "10px"}}/>*/}
                          {/*    <span>至</span>*/}
                          {/*    <Input onChange={this.handleChange.bind(this, 'time_end', index)}*/}
                          {/*           defaultValue={item.properties.multiPeriod.times[0][1]}*/}
                          {/*           style={{border: 0, width: '65px', fontSize: "10px"}}/>*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                          {/* <div className={'row_label'}>
                            <span className={'label_price'}>最大重量</span>
                            <Input onChange={this.handleChange.bind(this, 'max_weight', index)}
                                   className={'input_price'}
                                   defaultValue={item.properties.max_weight}
                                   addonAfter={'克'}/>
                          </div>*/}
                        </div>
                      </div>
                    </Skeleton>
                  </List.Item>
                )}
              />
              <div>
                <Button onClick={this.addArea.bind(this)} className='add_area'>添加配送区域</Button>
              </div>
              <div className='save_exist'>
                <Button type={'primary'} onClick={this.save.bind(this)}>
                  保存
                </Button>
                <Button type={'danger'} onClick={this.exist.bind(this)}>
                  返回
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  }


}




// WEBPACK FOOTER //
// ./src/pages/shopmanage/deliverymanage/editarea-flower/index.js